import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Box} from 'views/components';

import {FilterSettings} from 'views/module';

import FilterChipOption from './FilterChipOption';
import FilterOption from './FilterOption';

const Filter = (props) => {
  const selection = props.selection;
  const updateFilter = props.updateFilter;
  const onClearFilter = props.onClearFilter;
  const filterOptions = props.filterOptions;

  return (
    <Stack
      direction='row'
      alignItems={{md: 'center', xs: 'flex-start'}}
      flexWrap="wrap"
      sx={{
        width: 560,
      }}
    >
      <FilterOption
        updateFilter={updateFilter}
        filterOptions={filterOptions}
      />
      <FilterChipOption
        selection={selection}
        updateFilter={updateFilter}
        filterOptions={filterOptions}
      />
      <Box >
        <FilterSettings
          onClearFilter={onClearFilter}
        />
      </Box>
    </Stack>
  );
};

Filter.propTypes = {
  selection: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});


export default connect(mapStateToProps, dispatch)(React.memo(Filter));
